import { ActionTree, GetterTree, Module, MutationTree } from "vuex";

interface ICMS {
  admin: boolean;
}

const state: ICMS = {
  admin: false,
};
const mutations: MutationTree<ICMS> = {
  SET_ADMIN: (state: ICMS, value: boolean) => {
    state.admin = value;
  },
};
const actions: ActionTree<ICMS, IRootState> = {
  setAdmin({ commit }, payload: boolean) {
    commit("SET_ADMIN", payload);
  },
};
const getters: GetterTree<ICMS, IRootState> = {
  isAdmin(state: ICMS) {
    return state.admin;
  },
};

export const settings: Module<ICMS, IRootState> = {
  state,
  mutations,
  actions,
  getters,
};
